import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { apiConfig, apiGetPage } from '../../request/api'
import { useCustomData } from '../../pages/context/aboutCustomDataProvider';

import { RootState } from '../../store/index';

interface PageData {
    mineTitle: string;
    nextTitle: string;
    mianInfo: string;
    subInfo: string;
    firstCloum: string;
    secCloum: string;
    thirdCloum: string;
    fouthCloum: string;
}

const AboutPart5: React.FC = () => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const [partList, setPartList] = useState<PageData | null>(null);
    const { getValue } = useCustomData();
    const aboutHeaderLeft = getValue('aboutHeaderLeft');
    const aboutHeaderRight = getValue('aboutHeaderRight');
    const aboutHeaderRightContent = getValue('aboutHeaderRightContent');
    const aboutMapTitle = getValue('aboutMapTitle');


    return (
        <div>
            <div className='about-part3-content'>
                    <div className='about-part3-content-left'>{aboutHeaderLeft}</div>
                    <div className='about-part3-line'></div>
                    <div className='about-part3-content-right'>
                        <p>{aboutHeaderRight}</p>
                        <p>{aboutHeaderRightContent}</p>
                    </div>
                </div>
                <div className='about-h1'>{aboutMapTitle}</div>
        </div>
    );
};

export default AboutPart5;